<template>
  <div>
    <!--Success Alert-->
    <div class="alert alert-success text-left" role="alert" v-if="agencyMsgStatus">
      <span class="font-weight-bold" style="text-transform: capitalize ;">{{agencyName}}</span> has been created.
    </div>
    <!--Page Header-->
    <div class="row no-gutters mb-3 head-container">
      <div class="col-md-6 display-1">Agency Manager</div>
      <div class="col-md-6 text-right">
        <button type="button" class="btn btn-outline-success" id="add-agency">+Add Agency</button>
      </div>
    </div>
    <!--Table Head-->
    <div class="table-head rounded-top py-2 px-0 no-gutters">
      <b-container fluid>
      <b-row class="no-gutters">
        <b-col cols="12" md="4" class="my-auto text-left">Agency List</b-col>
        <b-col cols="12" md="8">
        <b-form-group class="search-box-admin mb-0 mt-sm-2 mt-md-0 float-md-right">
          <b-input-group>
            <b-input-group-text slot="prepend"><i class="fas fa-search"></i></b-input-group-text>
            <b-form-input v-model="filter" placeholder="Search Table" class="search-text-box-admin"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
       </b-row>
      </b-container>
    </div>
    <b-table hover id="manage-table" class="smaller-font-content"
      :items="formartedItems"
      :fields="fields"
       :responsive="true"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :sort-compare="dateSortCompare"
      primary-key="agencyId"
      @filtered="onFiltered"
    >
      <span slot="agency" slot-scope="data" v-html="data.value"></span>
      <span slot="agencyAdmin" slot-scope="data" v-html="data.value"></span>
      <b-form-checkbox slot="status" slot-scope="data" v-model="data.value" name="check-button" :id="'agency-'+data.item.agencyId"  @change="toggleAll(data)" switch>
      </b-form-checkbox>
      <span slot="editAgency" slot-scope="data" v-html="data.value"></span>
      <span slot="products" slot-scope="data" v-html="data.value"></span>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment';
import fetchData from '../../../services/fetchData';
import postData from '../../../services/postData';

export default {
  data() {
    return {
      agencyMsgStatus: false,
      agencyName: '',
      testValue: 0,
      items: [],
      fields: [
          { key: 'agency', sortable: true, sortDirection: 'desc' },
          { key: 'application', sortable: true, sortDirection: 'desc' },
          { key: 'agencyAdmin', sortable: true, sortDirection: 'desc' },
          { key: 'products', sortable: true, sortDirection: 'desc' },
          { key: 'dateAdded', sortable: true, sortDirection: 'desc' },
          { key: 'status', sortable: true, sortDirection: 'desc' },
          { key: 'editAgency', sortable: false },
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 20,
        pageOptions: [5, 10, 15],
        sortBy: 'agency',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        applications: [],
    };
  },
  methods: {
    /**
     * custom sort logic to sort records by date
     */
    dateSortCompare(valOne, valTwo, key) {
      if(key !== 'dateAdded') {
        return null;
      }
      const a = new Date(valOne.dateAdded);
      const b = new Date(valTwo.dateAdded);
      return a > b ? -1 : a < b ? 1 : 0;
    },
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      toggleAll(data) {
      if(data.value == true)
      {
          this.items.map((item, itemIndex) => {
            if(item.agencyId === data.item.agencyId)
            {
              this.items[itemIndex]._rowVariant = 'row-disable';
              this.items[itemIndex].status =  !data.value;
            }
          });
      }
      else
      {
          this.items.map((item, itemIndex) => {
            if(item.agencyId === data.item.agencyId)
            {
              this.items[itemIndex]._rowVariant = '';
              this.items[itemIndex].status =  !data.value;
            }
          });
      }
      const dataStatus = {
        status: !data.value
      };
      const requestParams = {
      url: '/agencies/'+data.item.agencyId+'/update-status',
      data: dataStatus,
    };
    postData.postRuleDashboard(requestParams).then((response) => {
       this.$forceUpdate();
    }).catch((error) => {
      alert('400 client error');
    });

    }
  },
  created() {
  },
  computed: {
  formartedItems () {
    if (!this.items) return []
    return this.items.map(item => {
      const application = this.applications.find(application => application.appId === item.appId) || {};
      item.application = application.displayName;

      if(item.status == false)
          item._rowVariant  = 'row-disable';
      else
          item._rowVariant  = '';
      return item;
    })
  }
},
  mounted() {
    /**
     * check if incoming url has any message to display on top
     */
    if (this.$route.query.msg && this.$route.query.msg === 'agencyCreated') {
      this.agencyMsgStatus = true;
      this.agencyName = (this.$route.query.carrier) ? this.$route.query.carrier : '';
    }

    fetchData.getDashboard('applications').then((response) => {
      this.applications = response.data;
    });

    fetchData.getDashboard('agencies').then((response) => {
      this.items = response.data.map(el => {

        if (!el.agencyAdmin) {
          el.agencyAdmin = {};
          el.agencyAdmin.fullName = '';
          el.agencyAdmin.email = '';
          el.agencyAdmin.phoneNumber = '';
        } else {
          if (el.agencyAdmin.fullName === null) el.agencyAdmin.fullName = '';
          if (el.agencyAdmin.email === null) el.agencyAdmin.email = '';
          if (el.agencyAdmin.phoneNumber === null) el.agencyAdmin.phoneNumber = '';
        }

        const agencyAdmin = `<strong>${el.agencyAdmin.fullName}</strong><br>
                ${el.agencyAdmin.email}<br>
                ${el.agencyAdmin.phoneNumber}`;

        const carrierLogo = `<a href="javascript:void(0)" class="edit-agency"><img alt="${el.agencyName}" height="auto" width="100%" src="${el.agencyLogo}" data-carrier="${el.agencyId}" class=""></a>`;

        const editAgency = `<a href="javascript:void(0)" class="edit-agency" data-carrier="${el.agencyId}"><i class="fas fa-edit" title="Edit Agency"></i> Edit Details</a>`;

        const createDate = moment(el.createdDate, 'YYYY-MM-DD[T]HH:mm:ss.SSS').format('MM/DD/YYYY'); 

        // Extracts available products
        const agencyProducts = el.products.map((prod) => {
          if (prod.ProductId === 1) {
            return 'Auto';
          }
          if (prod.ProductId === 21) {
            return 'Home';
          }
          if (prod.ProductId === 18) {
            return 'Condo';
          }
          if (prod.ProductId === 12) {
            return 'Renters';
          }
        });

        // Reference array for ordering products
        const productsInOrder = ['Auto', 'Home', 'Condo', 'Renters'];
        const sortedProducts = [];

        productsInOrder.forEach((prod) => {
          if (agencyProducts.includes(prod)) {
            sortedProducts.push(prod);
          };
        });

        const iconDictionary = {
          auto: 'car',
          home: 'home',
          condo: 'hotel',
          renters: 'building',
        };

        const agencyProductIconHtml = sortedProducts.map(el => {
          let productName = el.toLowerCase();
          return `<span class="product-icon-${productName} d-inline-flex justify-content-center">${el}</span>`;
        })

        const strAgencyProductIcons = agencyProductIconHtml.join('');

        return {
          agency: carrierLogo,
          appId: el.appId, // Not displayed. Used to look up the application's display name
          agencyAdmin,
          products: strAgencyProductIcons,
          dateAdded: createDate,
          status: el.status,
          editAgency,
          agencyId: el.agencyId
        }
      });

      this.totalRows = this.items.length;
      document.getElementById('manage-table').addEventListener('click', e => {
        if (e.target.classList.contains('edit-agency')) {
          e.preventDefault();
          this.$router.push({ path: '/dashboard/agencies/agencymanager/editagency', query: { agencyID:  e.target.dataset.carrier } });
        }
      });

      document.getElementById('add-agency').addEventListener('click', e => {
          this.$router.push({ name: 'addagency'});
      });
      

    }).catch((error) => {
      console.log('error', error);
    });
    // const pageFirstElement = document.getElementsByClassName('skip-to-content-link');
    // pageFirstElement[0].focus();
  },
};
</script>

<style scoped>
</style>

<style>
/**PAGE HEADER STYLING**/

/**DATA TABLE STYLING**/
.table-head{
  display: block;
  color: #FFFFFF;
  background: #00162B;
}
  #manage-table tbody td{
    position: relative;
    max-width: 300px;
    min-width: 100px;
  }
    #manage-table tbody td img{
      width: inherit !important;
      max-height: 60px !important;
    }
    /**Missing Agency Logo**/
    #manage-table tbody td img.edit-agency:after{
      font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
      content: "\f1c5" " " attr(alt);
      font-size: 1rem;
      color: #666666;
      display: block;
      position: absolute;
      top: 0.75rem;
      left: 0.75rem;
      z-index: 2;
      background-color: #fff;
    }
    /**Disabled agency missing image background color**/
    #manage-table tr.table-row-disable img.edit-agency:after{
      background-color: #eee !important;
    }

.table-row-disable {
  background-color: #eeeeee;
}
span[class^='product-icon'] {
  display: inline-flex;
  color: #fff;
  border-radius: 25px;
  padding: 0.3rem;
  align-items: center;
  justify-content: space-evenly;
  margin: 0.3rem;
  width: 4.5rem;
}
span.product-icon-auto {
  background-color: #DCDFE7;
  color: #2D374C;
}
span.product-icon-home {
  background-color: #DBE5E5;
  color: #314D4D;
}
span.product-icon-condo {
  background-color: #E6E0E7;
  color: #423545;
}
span.product-icon-renters {
  background-color: #ECE1CF;
  color: #603F0B;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/agencies/AgencyManager.vue?764bee5c